import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const PageTitle = styled.p`
  font-size: ${ThemePrisma.fonts.title.xl.lowContrast.fontSize};
  font-weight: ${ThemePrisma.fonts.title.xl.lowContrast.fontWeight};

  span {
    font-weight: ${ThemePrisma.fonts.title.xl.highContrast.fontWeight};
  }
`;

export const SectionTitle = styled.p`
  margin-top: 32px;
  font-size: ${ThemePrisma.fonts.title.l.lowContrast.fontSize};
  font-weight: ${ThemePrisma.fonts.title.l.lowContrast.fontWeight};

  span {
    font-weight: ${ThemePrisma.fonts.title.l.highContrast.fontWeight};
  }
`;

type AllowedTextColor =
  | 'primaryStronger'
  | 'primaryStrong'
  | 'primary'
  | 'primaryWeak'
  | 'secondaryStronger'
  | 'secondaryStrong'
  | 'secondary'
  | 'secondaryWeak'
  | 'neutralStrong'
  | 'neutral'
  | 'neutralWeak'
  | 'neutralWeaker'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | '';
const getFontColor = (color: AllowedTextColor): string => {
  switch (color) {
    case 'danger':
      return ThemePrisma.colors.red[5];
    case 'success':
      return ThemePrisma.colors.green[7];
    case 'warning':
      return ThemePrisma.colors.yellow[7];
    case 'info':
      return ThemePrisma.colors.blue[4];
    default:
      return ThemePrisma.colors.gray[8];
  }
};
export const PBody = styled.p<{ $bold?: boolean; $color?: AllowedTextColor }>`
  font-family: ${ThemePrisma.fonts.body.m.midContrast.fontFamily};
  font-size: ${ThemePrisma.fonts.body.m.midContrast.fontSize};
  font-weight: ${(props) =>
    props.$bold
      ? ThemePrisma.fonts.body.m.highContrast.fontWeight
      : ThemePrisma.fonts.body.m.midContrast.fontWeight};
  line-height: ${ThemePrisma.fonts.body.m.midContrast.lineHeight};
  letter-spacing: ${ThemePrisma.fonts.body.m.midContrast.letterSpacing};
  color: ${(props) => getFontColor(props.$color)};
`;
